import Echo from 'laravel-echo'
import type { ChannelAuthorizationData } from 'pusher-js/types/src/core/auth/options'
import { api, provideSocketId } from '@/shared/api'
import { config } from '@/shared/config'
import { Pusher } from '@/shared/platform/pusher'

/** Корень сайта API: /broadcasting/auth живёт рядом с /api, а не внутри. */
const root = config.apiUrl.replace(/\/api\/v1\/?$/, '')

export const echo = new Echo({
  broadcaster: 'reverb',
  /*
   * Reverb говорит по протоколу Pusher — клиент тот же. Реализацию приносит
   * площадка (platform/pusher): у Echo опция Pusher приоритетнее
   * window.Pusher, поэтому записи в глобал больше нет — в React Native
   * записывать было бы и некуда.
   */
  Pusher,
  key: config.reverb.key,
  wsHost: config.reverb.host,
  wsPort: config.reverb.port,
  wssPort: config.reverb.port,
  forceTLS: config.reverb.scheme === 'wss',
  enabledTransports: ['ws', 'wss'],
  authEndpoint: `${root}/broadcasting/auth`,

  /*
   * Приватные каналы авторизуются нашим axios, а не встроенным запросом
   * pusher-js. Причин две, и обе неустранимы настройкой:
   *
   *   - встроенный XHR не ставит withCredentials, а фронт и API живут на
   *     разных поддоменах — сессионная кука туда просто не поедет;
   *   - Sanctum в режиме SPA проверяет CSRF, а токен pusher-js ищет
   *     в мета-теге страницы, которого у SPA нет.
   *
   * У axios и то и другое уже настроено (см. src/api.ts).
   */
  authorizer: (channel: { name: string }) => ({
    authorize: (
      socketId: string,
      callback: (error: Error | null, data: ChannelAuthorizationData | null) => void,
    ): void => {
      api
        .post(`${root}/broadcasting/auth`, {
          socket_id: socketId,
          channel_name: channel.name,
        })
        .then((response) => callback(null, response.data as ChannelAuthorizationData))
        .catch((error: Error) => callback(error, null))
    },
  }),
})

/*
 * Отдаём axios свой номер сокета.
 *
 * По нему сервер не присылает нам событие о нашем же действии: свежее
 * состояние уже пришло в ответе на запрос. Здесь, а не в api.ts, потому что
 * там про echo знать нельзя — вышел бы круг из двух импортов.
 *
 * Геттер, а не значение: до подключения socketId() возвращает undefined,
 * и вычислять его надо в момент запроса, а не при загрузке модуля.
 */
provideSocketId(() => echo.socketId() ?? undefined)
